import React from "react";
import { Provider } from "react-redux";
import { store, history } from "./store";
import LayoutContainer from "containers/LayoutContainer";
import { EndSessionRequest } from "@azure/msal-browser";
import { Router, Switch } from "react-router";
import { ToastContainer } from "react-toastify";
import AuthRoute from "./components/common/PrivateRoute";
import Localization from "react-widgets/Localization";
import { DateLocalizer } from "react-widgets/IntlLocalizer";
import { useMsal } from '@azure/msal-react';

import config from "./config";

const dateLocalizer = new DateLocalizer({ culture: "en-US" });

const logoutRequest: EndSessionRequest = {
    postLogoutRedirectUri: config.msal.postLogoutRedirectUri,
};

//avoid extra rerender children components
const SingOutWrapper: React.FC<{ children: (signOut: () => void) => React.ReactNode; }> = ({ children }) => {
    const { instance } = useMsal();

    const signOut = () => {
        localStorage.removeItem("token");
        instance.logoutRedirect(logoutRequest);
    };

    return <>{children(signOut)}</>;
};

export default () => (
    <Provider store={store}>
        <Localization date={dateLocalizer}>
            <Router history={history}>
                <Switch>
                    <AuthRoute
                        path="/"
                        component={() => (
                            <SingOutWrapper>
                                {(signOut) => <LayoutContainer signOut={signOut} />}
                            </SingOutWrapper>
                        )}
                    />
                </Switch>

                <ToastContainer containerId="A" position="bottom-center" theme="colored" icon={false} />
            </Router>
        </Localization>
    </Provider>
);
